<template>
  <div class="table-container">
    <div class="filter-container">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="主题">
          <el-select v-model="filterForm.subject" placeholder="请选择主题" clearable>
            <el-option v-for="item in topicOptions" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleFilter">筛选</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border stripe style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>

      <el-table-column prop="name" label="姓名" width="100"></el-table-column>

      <el-table-column prop="email" label="邮箱" width="200"></el-table-column>

      <el-table-column prop="phone" label="电话" width="130"></el-table-column>

      <el-table-column prop="content" label="信息" min-width="200">
        <template slot-scope="scope" label-width="355">
          <pre style="max-width: 700px;white-space: pre-wrap;overflow-wrap: break-word;margin-bottom: 0px;margin-top: 0px;">{{ scope.row.content }}</pre>
        </template>
      </el-table-column>

      <el-table-column prop="subject" label="主题" width="100">
        <template slot-scope="scope">
          <el-tag :type="getTopicTagType(scope.row.subject)">
            {{ getSubjectLabel(scope.row.subject) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="时间" width="180" sortable>
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.createTime) }}
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态" width="150">
        <template slot-scope="scope">
          <el-select v-model="scope.row.status"
                     @change="toggleStatus(scope.$index, scope.row)"
                     :class="{'highlight-row': scope.row.status === 'UNPROCESSED'}">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="操作(是否需要?)" width="200" align="center">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-sizes="[8,16,24,32]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
const SubjectEnum = {
  LEARN_MORE: '了解更多',
  PRODUCT: '产品服务',
  COOPERATION: '合作意向',
  FEEDBACK: '意见反馈',
  JOIN_US: '加入我们',
  OTHER: '其它'
};

const MessageStatusEnum = {
  UNPROCESSED: '未处理',
  PROCESSED: '已处理',
  REJECTED: '已拒绝',
};

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 8,
      total: 0,
      filterForm: {
        subject: '',
        status: ''
      },
      topicOptions: Object.entries(SubjectEnum).map(([value, label]) => ({ value, label })),
      statusOptions: Object.entries(MessageStatusEnum).map(([value, label]) => ({ value, label })),
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    getSubjectLabel(value) {
      return SubjectEnum[value] || value;
    },
    fetchData() {
      this.loading = true;
      this.$api.getMessage({
        page: this.currentPage,
        nums: this.pageSize,
        ...(this.filterForm.subject ? { subject: this.filterForm.subject } : {}),
        ...(this.filterForm.status ? { status: this.filterForm.status } : {}),
      }).then(res => {
        if (res.code == 200) {
          const mockData = res.data.list;
          this.tableData = mockData.map((item, index) => ({
            ...item,
            index: index + 1
          }));
          this.total = res.data.total;
          this.$store.dispatch("getMessageNum");
        }
      });
      this.loading = false;
    },

    handleFilter() {
      this.currentPage = 1;
      this.fetchData();
    },

    resetFilter() {
      this.filterForm = {
        subject: '',
        status: ''
      };
      this.handleFilter();
    },

    toggleStatus(index, row) {
      this.$api.updateMessageStatus({
        id: row.id,
        status: row.status,
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '状态更新成功',
            type: 'success'
          });
          this.fetchData();
          // 使用Vuex action更新消息数量
          this.$store.dispatch('getMessageNum');
        } else {
          console.error('状态更新失败:', res.message);
          this.$message.error('状态更新失败');
        }
      });
    },
    handleDelete(index, row) {
      this.$confirm('确定要删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.deleteMessage({
          id: row.id
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
            this.fetchData();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    formatDateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    getTopicTagType(subject) {
      const types = {
        'LEARN_MORE': 'primary',
        'PRODUCT': 'success',
        'COOPERATION': 'info',
        'FEEDBACK': 'warning',
        'JOIN_US': 'success',
        'OTHER': 'warning'
      };
      return types[subject] || '';
    }
  }
}
</script>

<style scoped>
.table-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.filter-container {
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}

.highlight-row {
  background-color: #fff3e0; /* 浅黄色背景 */
  border: 1px solid #ffb74d; /* 橙色边框 */
}
</style>